import _ from 'underscore';
import browser from 'detect-browser';
import { scrollTo } from './utilities';

($ => {

	// Add browser and os class to body tag
	$('body').addClass( browser.name );

	let osName = "unknown";
	if (window.navigator.userAgent.indexOf("Windows")!= -1) osName="windows";
	if (window.navigator.userAgent.indexOf("Mac") != -1) osName="mac";
	if (window.navigator.userAgent.indexOf("X11") != -1) osName="unix";
	if (window.navigator.userAgent.indexOf("Linux") != -1) osName="linux";
	$('body').addClass( osName );

	// Initialize Foundation
	$( document ).foundation();

	// Foundation Equalizer fix
	const resetEqualizer = () => new Foundation.Equalizer( $('[data-equalizer]') );

	$( window ).load( resetEqualizer );
	$( window ).resize( resetEqualizer );

	// Disable Marketo form styles
	$( window ).load( () => {
		_.each( document.styleSheets, ( stylesheet, i ) => {
			const href = stylesheet.href || '';

			if( href.match(/lp\.bookshare\.org/) || href.match(/marketo\.com/) ) {
				document.styleSheets[i].disabled = true;
			}
		});
	});

	// Smooth scroll to anchors
	$('[href^=#]:not(.header-contentSkip)').click( event => {
		event.preventDefault();

		const $targetElement = $( $( event.currentTarget ).attr( 'href' ) );

		scrollTo( $targetElement );
	});

})(jQuery);



// WEBPACK FOOTER //
// ../benetech/js/initialize.js